module.exports = __webpack_public_path__ + "img/dne-holding.4f820da7.svg";